module.exports = __webpack_public_path__ + "f1ab747d48414b2320521c9b5940c505.pdf";